import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const FormRow = styled(Box)(({ theme }) => {
  const mobileMaxSize = theme.breakpoints.values.sm + 1;
  const mobile = theme.breakpoints.down(mobileMaxSize);

  return {
    display: 'flex',
    columnGap: '24px',
    [mobile]: {
      flexDirection: 'column',
      rowGap: '24px',
      columnGap: 0,
    },
  };
});
